import { RouteRecordRaw } from 'vue-router';
import { deltaGptRoutes, getResearchRoutes } from '../deltaGptRoutes.ts';
import { SectionRouteNames } from './sectionRouteNames.ts';

export const evsRoutes: Record<string, RouteRecordRaw> = {
    home: {
        path: '',
        name: `${SectionRouteNames.evs}Home`,
        components: {
            default: () => import('@/views/sectionViews/evs/EvsHomeView.vue'),
        },
        meta: {
            headName: 'EVs Home',
            displayTitle: 'Home',
        },
    },
    research: {
        path: 'research',
        name: `${SectionRouteNames.evs}Research`,
        redirect: { name: `${SectionRouteNames.evs}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(SectionRouteNames.evs),
        meta: {
            headName: 'Research',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    enact: {
        path: 'enact',
        name: `${SectionRouteNames.evs}Enact`,
        redirect: { name: 'EV Flexibility Index' },
        meta: {
            headName: 'Enact',
            displayTitle: 'Enact',
            showChildrenInNavbar: true,
            showChildrenInNavDropdown: true,
            searchMeta: {
                noSearch: true,
            },
        },
        children: [
            {
                path: 'ev-flexibility-index',
                name: `${SectionRouteNames.evs}EvFlexibilityIndex`,
                redirect: { name: 'EV Flexibility Index' },
                meta: {
                    headName: 'EV Flexibility Index',
                    searchMeta: {
                        noSearch: true,
                    },
                },
            },
        ],
    },
};
